import Icon from '@material-ui/icons/History';

import List from "./DonHisList";
//import Show from "./ExamhistoryShow";

export default {
  icon: Icon,
  list: List
};